import store from '../store';
import ApiClient from '@/client';
import { authenticatedLandingRoute } from '@/helpers/redirection-helpers';
import { ensureSafariUserManifest } from '@/helpers/pwa-helpers';

export default async function checkAuthentication({ next, to }) {
  const { commit, getters, dispatch } = store;
  const eventId = store.getters['CurrentEvent/getId'];
  const user = JSON.parse(localStorage.getItem(`tokens_${eventId}`));
  const eventIdFromRoute = window.location.host.split('.')[0];

  if (eventIdFromRoute) {
    // Check if we have a "session" cookie in our browser
    if (user) {
      await dispatch('Authentication/getUser');
      const response =
        await ApiClient.getFullEventInfoForEventCurrentlyLoggedInTo();
      const eventIdFromSession = response.data.eventId;
      const eventSlugFromSession = response.data.eventSlug;

      // If the event id from the "full event info", which relies on our
      // session and which event we are actually logged in to, does not
      // match the one in the route params, we logout the user and
      // redirect them to the login page for the new event,
      // then fetch the new event info and set that as the current event
      if (
        eventIdFromRoute !== eventIdFromSession &&
        eventIdFromRoute !== eventSlugFromSession
      ) {
        await dispatch(
          'CurrentEvent/loadAndCacheEventDetails',
          eventIdFromSession
        );
        await dispatch('Authentication/doLogout');
      } else {
        commit('CurrentEvent/setEventId', eventIdFromSession);
        dispatch('CurrentEvent/changeLanguage', response.data.languageId);
        commit('CurrentEvent/setEventDetails', response.data);
        commit('CurrentEvent/setHasFullEventDetails', true);
      }
    }

    const isLoggedIn = store.getters['Authentication/isLoggedIn'];

    // Ensure the Safari user-specific PWA manifest (OTP start_url) is in place
    // for silently-restored sessions, so subsequent "Add to Home Screen" works.
    if (isLoggedIn) {
      ensureSafariUserManifest();
    }

    if (isLoggedIn && to.name.startsWith('login')) {
      const isWebappEnabled = getters['CurrentEvent/isWebappEnabled'];
      const isLobbyEnabled = getters['CurrentEvent/isLobbyEnabled'];
      const isStageEnabled = getters['CurrentEvent/isStageEnabled'];

      // Redirect through next(), never $router.push. A push from inside a guard leaves THIS
      // navigation unresolved, and on an event whose only enabled platform page is the web app
      // the push is additionally a no-op, because the target route is the one the user is
      // already on. The result was a navigation that never completed and a blank screen.
      const landing = authenticatedLandingRoute(
        isWebappEnabled,
        isLobbyEnabled,
        isStageEnabled
      );

      return landing ? next({ name: landing }) : next();
    }

    // We are not logged in, nor are we trying to go to the login page
    if (!isLoggedIn && !to.name.startsWith('login')) {
      return next({ name: 'login' });
    }
  }

  return next();
}
